// extracted by mini-css-extract-plugin
export default {"tooltip_wrapper":"chart_tooltip_wrapper__scRsE"};